/* ============================================================
   HYPE SIDE — Os maiores do mundo (sections/hs-europa.liquid)

   O Painel: um só estado para toda a página.
     state = { kid, kit, league, q }
       kid    → equipamentos de criança (true) ou de adulto
       kit    → '1' principal · '2' alternativo · '3' terceiro
       league → chave da liga ou 'all'
       q      → texto da pesquisa de clube
   Os números ao lado de cada opção dizem quantos clubes aparecem se a
   escolheres AGORA, com os outros filtros como estão (como numa loja de
   roupa: nunca há becos sem saída escondidos).
   Se uma escolha não der nenhum clube, o painel larga o filtro que
   impede (primeiro a pesquisa, depois a liga, depois criança) e diz-o
   numa nota, em vez de mostrar uma página vazia.

   · Troca de equipamento / liga / público: os cartões viram em onda
     (mosaico na bancada). Só os do ecrã animam.
   · O clube que estava no ecrã fica no mesmo sítio depois de filtrar.
   · Estado no endereço (?liga=…&kit=…&crianca=1): os anúncios podem
     abrir a página já filtrada.
   · Teclado: cada grupo é um radiogroup (setas mudam, Tab salta de
     grupo); "/" vai para a pesquisa.
   · Sem animações para quem pede menos movimento.
   ============================================================ */

(function () {
  var KITS = { principal: '1', alternativo: '2', terceiro: '3' };
  var KIT_NAMES = { '1': 'principal', '2': 'alternativo', '3': 'terceiro' };
  var KIT_SAY = { '1': 'principais', '2': 'alternativas', '3': 'terceiras' };
  var EASE_OUT = 'cubic-bezier(0.22, 1, 0.36, 1)';

  function calm() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches || !Element.prototype.animate;
  }

  function fold(s) {
    return (s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function init(root) {
    if (!root || root.__hse) return;
    root.__hse = true;

    var $ = function (sel) { return root.querySelector(sel); };
    var $$ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

    var dock = $('[data-hse-dock]');
    var wall = $('[data-hse-wall]');
    var groups = $$('[data-hse-group]');
    var tiles = $$('[data-hse-tile]');
    var say = $('[data-hse-say]');
    var none = $('[data-hse-none]');
    var tokens = $('[data-hse-tokens]');
    var badge = $('[data-hse-badge]');
    var sheet = $('[data-hse-sheet]');
    var hasKids = !!$('[data-hse-aud]');
    var byClub = {};
    tiles.forEach(function (t) {
      t._kits = t.dataset.kits.split(',');
      t._q = fold(t.dataset.name);
      byClub[t.dataset.club] = t;
    });

    var DEF = { kid: false, kit: '1', league: 'all', q: '' };
    var state = { kid: false, kit: '1', league: 'all', q: '' };
    var busy = false;

    /* ---------- Doca colada por baixo do cabeçalho ---------- */
    function measure() {
      var header = document.querySelector('.section-header');
      var top = 0;
      // cabeçalho colado ("always"): a doca cola logo por baixo. A altura
      // não muda com o scroll, por isso não há atraso de um frame.
      if (header) {
        var pos = getComputedStyle(header).position;
        if ((pos === 'sticky' || pos === 'fixed') && !header.classList.contains('shopify-section-header-hidden')) {
          top = header.offsetHeight;
        }
      }
      root.style.setProperty('--hse-top', top + 'px');
      root.style.setProperty('--hse-dock-h', dock.offsetHeight + 'px');
      return top;
    }
    var topNow = measure();
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        dock.classList.toggle('is-stuck', dock.getBoundingClientRect().top <= topNow + 1 && window.scrollY > 0);
      });
    }, { passive: true });

    /* ---------- Regras: que clubes aparecem com um estado ---------- */
    function key(s, kit) { return (s.kid ? 'c' : '') + kit; }
    function modeSlots(t, kid) {
      return t._kits.filter(function (k) { return (k.charAt(0) === 'c') === kid; });
    }
    function matches(t, s) {
      if (s.league !== 'all' && t.dataset.league !== s.league) return false;
      if (s.q && t._q.indexOf(s.q) === -1) return false;
      if (!modeSlots(t, s.kid).length) return false;
      // adulto + principal: o clube aparece sempre (mostra o que tiver)
      return t._kits.indexOf(key(s, s.kit)) > -1 || (!s.kid && s.kit === '1');
    }
    function count(s) {
      var n = 0;
      for (var i = 0; i < tiles.length; i++) if (matches(tiles[i], s)) n++;
      return n;
    }
    function withState(patch) {
      var s = { kid: state.kid, kit: state.kit, league: state.league, q: state.q };
      for (var k in patch) s[k] = patch[k];
      return s;
    }

    /* ---------- Cartões ---------- */
    function setTileKit(tile, slot) {
      tile.dataset.kit = slot;
      var kid = slot.charAt(0) === 'c';
      tile.querySelectorAll('.hse-kit').forEach(function (k) { k.hidden = k.dataset.slot !== slot; });
      var shownSw = 0;
      tile.querySelectorAll('[data-hse-sw]').forEach(function (b) {
        var mine = (b.dataset.hseSw.charAt(0) === 'c') === kid;
        b.hidden = !mine;
        if (mine) shownSw++;
        b.setAttribute('aria-pressed', b.dataset.hseSw === slot ? 'true' : 'false');
      });
      var box = tile.querySelector('.hse-tile__sw');
      if (box) box.hidden = shownSw < 2;
      var n = tile.querySelector('.hse-tile__n');
      var c = parseInt(kid ? tile.dataset.nKid : tile.dataset.nAdult, 10) || 0;
      if (n) { n.textContent = c; n.hidden = c < 2; }
    }

    /* ---------- Número que conta até ao valor novo ---------- */
    function tick(el, to) {
      var from = parseInt(el.textContent, 10);
      if (isNaN(from) || from === to || calm()) { el.textContent = to; return; }
      var t0 = performance.now();
      cancelAnimationFrame(el._raf);
      (function step(now) {
        var p = Math.min(1, (now - t0) / 380);
        el.textContent = Math.round(from + (to - from) * (1 - Math.pow(1 - p, 3)));
        if (p < 1) el._raf = requestAnimationFrame(step);
      })(t0);
    }

    /* ---------- Indicador que desliza até à escolha ---------- */
    function place(group) {
      var ind = group.querySelector(':scope > .hse-ind');
      var on = group.querySelector('[aria-checked="true"]');
      if (!ind || !on || !on.offsetWidth) return;
      var line = group.classList.contains('hse-tabs');
      var h = line ? 3 : on.offsetHeight;
      var y = line ? on.offsetTop + on.offsetHeight - 3 : on.offsetTop;
      ind.style.width = on.offsetWidth + 'px';
      ind.style.height = h + 'px';
      ind.style.transform = 'translate(' + on.offsetLeft + 'px,' + y + 'px)';
      if (!ind.classList.contains('is-ready')) {
        // primeira vez: aparece já no sítio, sem deslizar desde o canto
        ind.style.transition = 'none';
        void ind.offsetWidth;
        ind.style.transition = '';
        ind.classList.add('is-ready');
      }
    }
    function placeAll() { $$('[role="radiogroup"]').forEach(place); }

    function scrollIntoRow(row, el) {
      if (!row || !el || row.scrollWidth <= row.clientWidth) return;
      var left = el.offsetLeft - row.clientWidth / 2 + el.offsetWidth / 2;
      row.scrollTo({ left: left, behavior: calm() ? 'auto' : 'smooth' });
    }

    /* ---------- Estado → página ---------- */
    function render(kitChanged) {
      var shown = 0;
      tiles.forEach(function (t) {
        var visible = matches(t, state);
        t.hidden = !visible;
        if (visible) shown++;
        var mine = modeSlots(t, state.kid);
        if (kitChanged && mine.length) {
          var k = key(state, state.kit);
          setTileKit(t, t._kits.indexOf(k) > -1 ? k : mine[0]);
        }
      });
      groups.forEach(function (g) {
        var n = g.querySelectorAll('[data-hse-tile]:not([hidden])').length;
        g.hidden = n === 0;
        var c = g.querySelector('.hse-league__count');
        if (c) c.textContent = n + (n === 1 ? ' clube' : ' clubes');
      });

      // opções: marcada, número e "zero" para cada uma (doca e folha)
      $$('[data-hse-aud]').forEach(function (b) {
        var v = b.dataset.hseAud === '1';
        var on = v === state.kid;
        b.setAttribute('aria-checked', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
        b.classList.toggle('is-zero', !on && count(withState({ kid: v })) === 0);
      });
      $$('[data-hse-group-aud]').forEach(function (g) { g.dataset.on = state.kid ? '1' : '0'; });
      $$('[data-hse-kit]').forEach(function (b) {
        var on = b.dataset.hseKit === state.kit;
        var n = count(withState({ kit: b.dataset.hseKit }));
        b.setAttribute('aria-checked', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
        b.classList.toggle('is-zero', !on && n === 0);
        var small = b.querySelector('[data-hse-n]');
        if (small) small.textContent = n;
      });
      $$('[data-hse-league]').forEach(function (b) {
        var on = b.dataset.hseLeague === state.league;
        var n = count(withState({ league: b.dataset.hseLeague }));
        b.setAttribute('aria-checked', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
        b.classList.toggle('is-zero', !on && n === 0);
        var small = b.querySelector('[data-hse-n]');
        if (small) small.textContent = n;
        if (on && b.closest('.hse-tabs')) scrollIntoRow(b.closest('.hse-tabs'), b);
      });
      placeAll();

      // resultado
      $$('[data-hse-total]').forEach(function (el) { tick(el, shown); });
      $$('[data-hse-unit]').forEach(function (el) { el.textContent = shown === 1 ? 'clube' : 'clubes'; });

      // frase: o que estás a ver, por palavras
      var leagueBtn = $('.hse-tabs [data-hse-league="' + state.league + '"]');
      var bits = ['camisolas <b>' + KIT_SAY[state.kit] + '</b>'];
      bits.push(state.kid ? 'de <b>criança</b>' : 'de adulto');
      bits.push(state.league === 'all' ? 'de todas as ligas' : 'da <b>' + esc(leagueBtn ? leagueBtn.dataset.label : '') + '</b>');
      if (state.q) bits.push('com “<b>' + esc(state.q) + '</b>”');
      say.innerHTML = 'A mostrar <b>' + shown + (shown === 1 ? ' clube' : ' clubes') + '</b> · ' + bits.join(' ');

      // filtros ativos
      var active = [];
      if (state.league !== 'all') active.push('league');
      if (state.kid) active.push('kid');
      if (state.q) active.push('q');
      var dirty = active.length > 0 || state.kit !== '1';
      $$('[data-hse-reset]').forEach(function (b) { if (b.closest('.hse-dock')) b.hidden = !dirty; });

      if (badge) {
        var nb = active.length;
        if (String(nb) !== badge.textContent) {
          badge.textContent = nb;
          badge.classList.remove('is-bump');
          void badge.offsetWidth;
          badge.classList.add('is-bump');
        }
        badge.hidden = nb === 0;
      }

      if (tokens) {
        var html = '';
        var x = '<span class="hse-token__x" aria-hidden="true"><svg viewBox="0 0 20 20" fill="none"><path d="m6 6 8 8M14 6l-8 8" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg></span>';
        if (state.league !== 'all' && leagueBtn) {
          var img = leagueBtn.querySelector('img');
          html += '<button type="button" class="hse-token" data-hse-drop="league" aria-label="Tirar filtro ' + esc(leagueBtn.dataset.label) + '">' +
            (img ? '<img src="' + esc(img.currentSrc || img.src) + '" alt="">' : '') + esc(leagueBtn.dataset.label) + x + '</button>';
        }
        if (state.kid) html += '<button type="button" class="hse-token hse-token--kid" data-hse-drop="kid" aria-label="Tirar filtro criança">Criança' + x + '</button>';
        if (state.q) html += '<button type="button" class="hse-token" data-hse-drop="q" aria-label="Tirar pesquisa ' + esc(state.q) + '">“' + esc(state.q) + '”' + x + '</button>';
        if (active.length > 1) html += '<button type="button" class="hse-token hse-token--clear" data-hse-reset>Limpar tudo</button>';
        tokens.innerHTML = html;
        tokens.hidden = !html;
        measure();
      }

      // sem resultados (só acontece com a pesquisa)
      if (none) {
        none.hidden = shown > 0;
        if (!shown) {
          $('[data-hse-none-t]').textContent = state.q
            ? 'Nenhum clube com “' + state.q + '” aqui'
            : 'Nada com estes filtros';
          var acts = '';
          if (state.q) acts += '<button type="button" data-hse-drop="q">Limpar pesquisa</button>';
          if (state.league !== 'all' || state.kid || state.kit !== '1') acts += '<button type="button" data-hse-reset>Procurar em tudo</button>';
          $('[data-hse-none-acts]').innerHTML = acts;
        }
      }

      $$('.hse-search').forEach(function (s) { s.classList.toggle('has-q', !!state.q); });
      $$('[data-hse-qx]').forEach(function (b) { b.hidden = !state.q; });

      var url = new URL(location.href);
      if (state.league === 'all') url.searchParams.delete('liga'); else url.searchParams.set('liga', state.league);
      if (state.kit === '1') url.searchParams.delete('kit'); else url.searchParams.set('kit', KIT_NAMES[state.kit]);
      if (state.kid) url.searchParams.set('crianca', '1'); else url.searchParams.delete('crianca');
      history.replaceState(history.state, '', url.pathname + url.search + url.hash);
    }

    /* ---------- Mosaico: virar os cartões em onda ---------- */
    function onScreen(el) {
      if (el.hidden) return false;
      var r = el.getBoundingClientRect();
      return r.bottom > 0 && r.top < window.innerHeight && r.width > 0;
    }

    function anchor() {
      // o primeiro cartão visível abaixo da doca: fica no mesmo sítio depois de mudar
      var limit = topNow + dock.offsetHeight;
      for (var i = 0; i < tiles.length; i++) {
        if (tiles[i].hidden) continue;
        var r = tiles[i].getBoundingClientRect();
        if (r.bottom > limit + 40) return { el: tiles[i], top: r.top };
      }
      return null;
    }

    function restore(a) {
      var wallTop = wall.getBoundingClientRect().top;
      var limit = topNow + dock.offsetHeight;
      if (a && !a.el.hidden) {
        window.scrollBy(0, a.el.getBoundingClientRect().top - a.top);
      } else if (wallTop < limit) {
        window.scrollBy(0, wallTop - limit);
      }
    }

    function wave(change) {
      var a = anchor();
      if (calm() || busy || (sheet && sheet.open)) {
        change();
        restore(a);
        return;
      }
      busy = true;
      var before = tiles.filter(onScreen);
      var outs = before.map(function (t, i) {
        return t.animate(
          [{ transform: 'rotateY(0deg)', opacity: 1 }, { transform: 'rotateY(90deg)', opacity: 0.2 }],
          { duration: 170, delay: Math.min(i * 14, 160), easing: 'cubic-bezier(0.5, 0, 0.75, 0)', fill: 'forwards' }
        );
      });
      // salvaguarda: com o separador em segundo plano as animações param;
      // a troca nunca pode ficar à espera delas
      var done = Promise.all(outs.map(function (o) { return o.finished; })).catch(function () {});
      var guard = new Promise(function (r) { setTimeout(r, 500); });
      var once = false;
      Promise.race([done, guard]).then(function () {
        if (once) return;
        once = true;
        change();
        restore(a);
        var after = tiles.filter(onScreen);
        var minTop = Infinity;
        var minLeft = Infinity;
        var w = 1;
        var h = 1;
        var rects = after.map(function (t) {
          var r = t.getBoundingClientRect();
          minTop = Math.min(minTop, r.top);
          minLeft = Math.min(minLeft, r.left);
          w = r.width;
          h = r.height;
          return r;
        });
        after.forEach(function (t, i) {
          var row = Math.round((rects[i].top - minTop) / (h + 1));
          var col = Math.round((rects[i].left - minLeft) / (w + 1));
          t.animate(
            [{ transform: 'rotateY(-90deg)', opacity: 0.2 }, { transform: 'rotateY(0deg)', opacity: 1 }],
            { duration: 460, delay: Math.min((row + col) * 70, 560), easing: EASE_OUT, fill: 'backwards' }
          );
        });
        outs.forEach(function (o) { o.cancel(); });
        busy = false;
      });
    }

    /* ---------- Nota quando o painel ajusta um filtro sozinho ---------- */
    var toast = document.createElement('p');
    toast.className = 'hse-toast';
    toast.setAttribute('role', 'status');
    document.body.appendChild(toast);
    var toastT;
    function note(msg) {
      toast.textContent = msg;
      toast.classList.add('is-on');
      clearTimeout(toastT);
      toastT = setTimeout(function () { toast.classList.remove('is-on'); }, 3600);
    }

    /* ---------- Mudar o estado (com a inteligência de não dar zero) ---------- */
    function labelOf(lk) {
      var b = $('.hse-tabs [data-hse-league="' + lk + '"]');
      return b ? b.dataset.label : '';
    }
    function apply(patch, opts) {
      opts = opts || {};
      var next = withState(patch);
      var msg = '';
      if (count(next) === 0 && !opts.strict) {
        // larga o filtro que não foi tocado agora, por esta ordem
        if (next.q && !('q' in patch)) {
          msg = '“' + next.q + '” não aparece aqui — tirámos a pesquisa.';
          next.q = '';
          setQueryInputs('');
        }
        if (count(next) === 0 && next.league !== 'all' && !('league' in patch)) {
          msg = 'Não há ' + KIT_SAY[next.kit] + (next.kid ? ' de criança' : '') + ' na ' + labelOf(next.league) + ' — a mostrar todas as ligas.';
          next.league = 'all';
        }
        if (count(next) === 0 && next.kid && !('kid' in patch)) {
          next.kid = false;
          msg = 'Sem equipamento de criança com esta escolha — a mostrar adulto.';
        }
        if (count(next) === 0 && next.kit !== '1' && !('kit' in patch)) {
          next.kit = '1';
          msg = 'A mostrar as camisolas principais.';
        }
      }
      var kitChanged = next.kit !== state.kit || next.kid !== state.kid;
      var same = next.kit === state.kit && next.kid === state.kid && next.league === state.league && next.q === state.q;
      if (same) return;
      var go = function () {
        state = next;
        render(kitChanged);
      };
      if (opts.quiet) {
        var a = anchor();
        go();
        if (!opts.noRestore) restore(a);
      } else {
        wave(go);
      }
      if (msg) note(msg);
    }

    /* ---------- Opções: clique e teclado ---------- */
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-hse-aud],[data-hse-kit],[data-hse-league],[data-hse-drop],[data-hse-reset]');
      if (!b || !root.contains(b)) return;
      if (b.hasAttribute('data-hse-aud')) apply({ kid: b.dataset.hseAud === '1' });
      else if (b.hasAttribute('data-hse-kit')) apply({ kit: b.dataset.hseKit });
      else if (b.hasAttribute('data-hse-league')) apply({ league: b.dataset.hseLeague });
      else if (b.hasAttribute('data-hse-drop')) {
        var what = b.dataset.hseDrop;
        if (what === 'league') apply({ league: 'all' });
        if (what === 'kid') apply({ kid: false });
        if (what === 'q') setQuery('');
      } else if (b.hasAttribute('data-hse-reset')) {
        setQueryInputs('');
        apply({ kid: DEF.kid, kit: DEF.kit, league: DEF.league, q: DEF.q }, { strict: true });
      }
    });

    // radiogroup: setas mudam a escolha (padrão ARIA), Home/End vão aos extremos
    root.addEventListener('keydown', function (e) {
      var opt = e.target.closest('[role="radio"]');
      if (!opt) return;
      var group = opt.closest('[role="radiogroup"]');
      var opts = Array.prototype.slice.call(group.querySelectorAll('[role="radio"]'));
      var i = opts.indexOf(opt);
      var j = -1;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') j = (i + 1) % opts.length;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') j = (i - 1 + opts.length) % opts.length;
      else if (e.key === 'Home') j = 0;
      else if (e.key === 'End') j = opts.length - 1;
      if (j < 0) return;
      e.preventDefault();
      opts[j].focus();
      opts[j].click();
    });

    /* ---------- Pesquisa de clube (na doca e na folha) ---------- */
    var qTimer;
    function setQueryInputs(v) {
      $$('[data-hse-q]').forEach(function (i) { if (i.value !== v) i.value = v; });
    }
    function setQuery(v) {
      setQueryInputs(v);
      var q = fold(v);
      if (q === state.q) return;
      var wasEmpty = !state.q;
      apply({ q: q }, { quiet: true, strict: true, noRestore: true });
      // ao começar a escrever, a bancada sobe até à doca: os resultados ficam à vista
      var limit = topNow + dock.offsetHeight;
      var wallTop = wall.getBoundingClientRect().top;
      if (q && (wasEmpty || wallTop < limit)) {
        if (Math.abs(wallTop - limit) > 4 && !(sheet && sheet.open)) window.scrollBy(0, wallTop - limit);
      }
    }
    root.addEventListener('input', function (e) {
      if (!e.target.matches('[data-hse-q]')) return;
      var v = e.target.value;
      clearTimeout(qTimer);
      qTimer = setTimeout(function () { setQuery(v); }, 110);
    });
    root.addEventListener('keydown', function (e) {
      if (!e.target.matches('[data-hse-q]')) return;
      if (e.key === 'Escape') {
        if (e.target.value) { e.preventDefault(); setQuery(''); }
      } else if (e.key === 'Enter') {
        e.preventDefault();
        clearTimeout(qTimer);
        setQuery(e.target.value);
        if (sheet && sheet.open) sheet.close();
        else e.target.blur();
        var first = tiles.filter(function (t) { return !t.hidden; })[0];
        if (first && state.q) {
          first.scrollIntoView({ behavior: calm() ? 'auto' : 'smooth', block: 'center' });
          flash(first);
        }
      }
    });
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-hse-qx]')) setQuery('');
    });
    // "/" vai direto à pesquisa (computador)
    document.addEventListener('keydown', function (e) {
      if (e.key !== '/' || e.metaKey || e.ctrlKey || e.altKey) return;
      var t = e.target;
      if (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName)) return;
      var input = $('.hse-dock [data-hse-q]');
      if (!input || !input.offsetParent) return;
      e.preventDefault();
      input.focus();
    });

    /* ---------- Folha de filtros (telemóvel) ---------- */
    if (sheet && typeof sheet.showModal === 'function') {
      var built = false;
      var build = function () {
        if (built) return;
        built = true;
        var search = $('.hse-dock .hse-search');
        if (search) $('[data-hse-sheet-search]').appendChild(search.cloneNode(true));
        var aud = $('[data-hse-sheet-aud]');
        var audSrc = $$('.hse-dock [data-hse-aud]');
        if (audSrc.length) audSrc.forEach(function (b) { aud.appendChild(b.cloneNode(true)); });
        else $('[data-hse-sheet-aud-wrap]').hidden = true;
        var kit = $('[data-hse-sheet-kit]');
        $$('.hse-dock [data-hse-kit]').forEach(function (b) { kit.appendChild(b.cloneNode(true)); });
        var lg = $('[data-hse-sheet-league]');
        $$('.hse-dock [data-hse-league]').forEach(function (b) { lg.appendChild(b.cloneNode(true)); });
        setQueryInputs(state.q);
      };
      $('[data-hse-open]').addEventListener('click', function () {
        build();
        render(false);
        sheet.showModal();
        var on = sheet.querySelector('[aria-checked="true"]');
        if (on) on.focus({ preventScroll: true });
      });
      sheet.addEventListener('click', function (e) {
        if (e.target === sheet || e.target.closest('[data-hse-close]')) sheet.close();
      });
      sheet.addEventListener('close', function () {
        // ao fechar, a bancada começa logo por baixo da doca
        var limit = topNow + dock.offsetHeight;
        var wallTop = wall.getBoundingClientRect().top;
        if (wallTop < limit || wallTop > window.innerHeight * 0.6) window.scrollBy(0, wallTop - limit);
      });
    }

    /* ---------- Um só cartão: trocar o equipamento desse clube ---------- */
    root.addEventListener('click', function (e) {
      var sw = e.target.closest('[data-hse-sw]');
      if (!sw || !root.contains(sw)) return;
      var tile = sw.closest('[data-hse-tile]');
      var slot = sw.dataset.hseSw;
      if (tile.dataset.kit === slot) return;
      if (calm()) return setTileKit(tile, slot);
      var out = tile.animate(
        [{ transform: 'rotateY(0deg)' }, { transform: 'rotateY(90deg)' }],
        { duration: 140, easing: 'cubic-bezier(0.5, 0, 0.75, 0)', fill: 'forwards' }
      );
      var swapped = false;
      Promise.race([out.finished.catch(function () {}), new Promise(function (r) { setTimeout(r, 300); })]).then(function () {
        if (swapped) return;
        swapped = true;
        setTileKit(tile, slot);
        tile.animate([{ transform: 'rotateY(-90deg)' }, { transform: 'rotateY(0deg)' }], { duration: 380, easing: EASE_OUT });
        out.cancel();
      });
    });

    /* ---------- Ir até um clube ---------- */
    function flash(tile) {
      tile.classList.remove('is-target');
      void tile.offsetWidth;
      tile.classList.add('is-target');
      tile.addEventListener('animationend', function () { tile.classList.remove('is-target'); }, { once: true });
    }
    function goTo(handle) {
      var tile = byClub[handle];
      if (!tile) return;
      if (!matches(tile, state)) {
        // abre caminho até ao clube sem mexer no que não é preciso
        var patch = {};
        if (state.q && tile._q.indexOf(state.q) === -1) { patch.q = ''; setQueryInputs(''); }
        if (state.league !== 'all' && tile.dataset.league !== state.league) patch.league = 'all';
        if (!modeSlots(tile, state.kid).length) patch.kid = false;
        var s = withState(patch);
        if (!matches(tile, s)) patch.kit = '1';
        apply(patch, { quiet: true, strict: true });
      }
      tile.scrollIntoView({ behavior: calm() ? 'auto' : 'smooth', block: 'center' });
      flash(tile);
      var link = tile.querySelector('.hse-kit:not([hidden]) .hse-kit__info');
      if (link) link.focus({ preventScroll: true });
    }
    root.addEventListener('click', function (e) {
      var j = e.target.closest('[data-hse-jump]');
      if (!j || !root.contains(j)) return;
      e.preventDefault();
      goTo(j.dataset.hseJump);
    });

    /* ---------- Fila de escudos: setas e sombras nas pontas ---------- */
    var rail = $('[data-hse-rail]');
    var ribbon = $('[data-hse-ribbon]');
    if (rail && ribbon) {
      var prev = $('[data-hse-rail-prev]');
      var next = $('[data-hse-rail-next]');
      prev.hidden = false;
      next.hidden = false;
      var railTick = false;
      var railState = function () {
        railTick = false;
        var max = ribbon.scrollWidth - ribbon.clientWidth - 2;
        var atStart = ribbon.scrollLeft <= 2;
        var atEnd = ribbon.scrollLeft >= max;
        rail.classList.toggle('is-start', atStart);
        rail.classList.toggle('is-end', atEnd);
        prev.disabled = atStart;
        next.disabled = atEnd;
      };
      var step = function (dir) {
        ribbon.scrollBy({ left: dir * ribbon.clientWidth * 0.8, behavior: calm() ? 'auto' : 'smooth' });
      };
      prev.addEventListener('click', function () { step(-1); });
      next.addEventListener('click', function () { step(1); });
      ribbon.addEventListener('scroll', function () {
        if (railTick) return;
        railTick = true;
        requestAnimationFrame(railState);
      }, { passive: true });
      window.addEventListener('resize', railState);
      railState();
    }

    /* ---------- O teu clube: vai para o início da fila de escudos ---------- */
    try {
      var seen = JSON.parse(localStorage.getItem('hs_clubs') || '[]');
      for (var s = 0; s < seen.length; s++) {
        var mineCrest = ribbon && ribbon.querySelector('[data-hse-jump="' + seen[s] + '"]');
        if (!mineCrest) continue;
        mineCrest.classList.add('is-mine');
        var tag = document.createElement('span');
        tag.className = 'hse-crest__tag';
        tag.textContent = 'O teu';
        mineCrest.querySelector('.hse-crest__logo').appendChild(tag);
        mineCrest.setAttribute('aria-label', mineCrest.textContent.trim() + ' (o teu clube)');
        ribbon.insertBefore(mineCrest, ribbon.firstChild);
        break;
      }
    } catch (e) {}

    /* ---------- Estado inicial pelo endereço ---------- */
    var params = new URLSearchParams(location.search);
    var k = KITS[params.get('kit')];
    var l = params.get('liga');
    if (k && $('[data-hse-kit="' + k + '"]')) state.kit = k;
    if (l && $('[data-hse-league="' + l + '"]')) state.league = l;
    if (hasKids && params.get('crianca') === '1') state.kid = true;
    render(true);

    var resizeT;
    window.addEventListener('resize', function () {
      clearTimeout(resizeT);
      resizeT = setTimeout(function () { topNow = measure(); placeAll(); }, 100);
    });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(placeAll);
  }

  function boot() {
    document.querySelectorAll('[data-hse]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
